(function () {
  const state = {
    conversationId: null,
    hasActiveHumanChat: false,
  };
  // Set config for the chatPanel
  var config = {
    chatPanel: {
      styling: {
        pace: 'supersonic',
      },
    },
  };
  // Create chat panel
  var { chatPanel } = window.boostInit('createroom', config);
  chatPanel.addEventListener('conversationIdChanged', ({ detail }) => {
    state.conversationId = detail.conversationId;
  });
  // GA integration
  chatPanel.addEventListener('ga', (e) => {
    ga.getAll()[0].send('event', e.deatil.category, e.deatil.action, e.deatil.label, e.deatil.value);
  });

  // Open panel on click
  document.querySelector('.modal_trigger').addEventListener('click', function () {
    chatPanel.show();
  });
  const showChatTrigger = () => {
    document.querySelector('.modal_trigger').classList.remove('chat-trigger-hidden');
  };
  const hideChatTrigger = () => {
    document.querySelector('.modal_trigger').classList.add('chat-trigger-hidden');
  };
  zE('webWidget', 'hide');
  zE('webWidget:on', 'chat:end', () => {
    state.hasActiveHumanChat = false;
    fetch('https://createroom.boost.ai/api/chat/v2', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        command: 'POLLSTOP',
        conversation_id: state.conversationId,
      }),
    }).then(() => {
      chatPanel.show();
    });
  });
  zE('webWidget:on', 'chat:status', (status) => {
    chatPanel.setCustomPayload(
      JSON.stringify({
        zendeskStatus: status,
      })
    );
  });
  zE('webWidget:on', 'close', () => {
    if (state.hasActiveHumanChat) {
      zE('webWidget', 'show');
    } else {
      zE('webWidget', 'hide');
      showChatTrigger();
    }
  });
  chatPanel.addEventListener('openZendesk', ({ detail }) => {
    hideChatTrigger();
    if (detail && detail.userEmail) {
      zE('webWidget', 'identify', {
        email: detail.userEmail,
      });
    }
    if (detail && detail.chatHistory) {
      zE('webWidget', 'chat:send', detail.chatHistory);
    }
    if (detail && detail.skill) {
      zE('webWidget', 'chat:addTags', detail.skill);
    }
    chatPanel.minimize();
    zE('webWidget', 'show');
    zE('webWidget', 'open');
    state.hasActiveHumanChat = true;
  });
})();
